import React from 'react';
import Axios from 'axios';
import { Link, Redirect } from 'react-router-dom';
import { API_HOST, axiosInstance, axiosRequestWithAuth } from './../../constants/server.constant';

export default class ReferralNav extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            userId: localStorage.getItem("userId"),

        };
    }

    componentDidMount() {

    }


    render() {

        let roleid = localStorage.getItem("roleId");
        let geturl = window.location.href;

        return (
            <aside className="referralModule_nav">
                <div className="settingModule_bg_shadow"></div>
                <ul className='referralNav'>
                    <li className={ geturl.indexOf("referral_linking_code") !== -1 ? "linking_code_li active" : "linking_code_li" }>
                        <Link to="/referral/referral_linking_code" onClick={ () => this.props.addNavclassOnNavClick('ref_linking') }>
                            <span class="svg_wrap">
                                <svg x="0px" y="0px" viewBox="0 0 21.9 21" enableBackground="new 0 0 21.9 21;" xmlSpace="preserve">
                                    <g>
                                        <g>
                                            <path class="lnkcode0" d="M13.6,11.6L9.8,7.9c-0.4-0.4-0.4-1.2,0-1.6l4.5-4.5c0.4-0.4,1.2-0.4,1.6,0l3.7,3.7c0.4,0.4,0.4,1.2,0,1.6
                                      l-4.5,4.5C14.7,12.1,14,12.1,13.6,11.6z"></path>
                                            <path class="lnkcode0" d="M6,19.2l-3.7-3.7c-0.4-0.4-0.4-1.2,0-1.6l4.5-4.5c0.4-0.4,1.2-0.4,1.6,0l3.7,3.7c0.4,0.4,0.4,1.2,0,1.6
                                      l-4.5,4.5C7.2,19.6,6.4,19.6,6,19.2z"></path>
                                        </g>
                                        <line class="lnkcode1" x1="14.4" y1="7.1" x2="7.5" y2="13.9"></line>
                                    </g>
                                </svg>
                            </span>Linking Code
                        </Link>
                    </li>
                    <li className={ geturl.indexOf("assests") !== -1 ? "assets_li active" : "assets_li" }  >
                        <Link to="/referral/assests" onClick={ () => this.props.addNavclassOnNavClick('ref_assets') }>
                            <span class="svg_wrap">
                                <svg x="0px" y="0px" viewBox="0 0 16 16" enableBackground="new 0 0 16 16;" xmlSpace="preserve">
                                    <g>
                                        <path class="as0" d="M12.6,13.7L12.6,13.7c-0.4,0-0.7-0.3-0.7-0.7V2.3c0-0.4,0.3-0.7,0.7-0.7h0c0.4,0,0.7,0.3,0.7,0.7v10.6
                                          C13.4,13.3,13,13.7,12.6,13.7z"/>
                                        <path class="as0" d="M13.1,5.7c1,0.1,1.8,0.9,1.8,1.9c0,0.9-0.7,1.7-1.5,1.9" />
                                        <path class="as1" d="M11.8,2.6c0,0-3.9,2.3-5.8,2.4L3.7,5C2.3,5,1.1,6.2,1.1,7.6v0c0,1.4,1.1,2.6,2.6,2.6l2.3,0
                                          c0,0,3.5,0.5,5.8,2.7"/>
                                        <path class="as1" d="M6,5.1l-0.1,5.2c0,0,0.2,2.4,0.8,3.8c0.1,0.2-0.1,0.4-0.3,0.4H4c-0.2,0-0.3-0.2-0.3-0.4
                                          c0.2-0.8,0.6-2.7,0.2-3.8"/>
                                        <path class="as1" d="M7.1,10.5c0,0,0.6,1.2-0.9,1.6" />
                                        <line class="as1" x1="2.8" y1="6.8" x2="4.6" y2="6.8" />
                                        <line class="as1" x1="2.8" y1="8.4" x2="4.6" y2="8.4" />
                                    </g>
                                </svg>
                            </span>
                            Assets
                        </Link>
                    </li>
                    <li class={ geturl.indexOf("referral_statistics") !== -1 ? "stats_li active" : "stats_li" }>
                        <Link to="/referral/referral_statistics" onClick={ () => this.props.addNavclassOnNavClick('ref_statistics') }>
                            <span class="svg_wrap">
                                <svg viewBox="0 0 22 22" enableBackground="new 0 0 22 22;" xmlSpace="preserve">
                                    <g>
                                        <polyline class="sts0" points="1.2,1.2 1.2,16.8 16.8,16.8  " />
                                        <polyline class="sts0" points="1.2,16.8 8.5,8.4 10.3,9.9 16.1,3.8  " />
                                        <polyline class="sts0" points="10.8,3.6 16.3,3.6 16.3,9.2  " />
                                    </g>
                                </svg>
                            </span>
                            Statistics
                        </Link>
                    </li>

                </ul >
            </aside >
        );
    }
}